
const features = [
  {
    icon: 'ri-medal-line',
    title: 'Kaliteli İşçilik',
    description: 'Uzman ekibimiz ve yılların deneyimiyle her projede mükemmellik'
  },
  {
    icon: 'ri-palette-line',
    title: 'Özel Tasarım',
    description: 'Size özel 3D tasarım ve proje hizmetleri'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantili Hizmet',
    description: 'Tüm ürünlerimizde garanti ve satış sonrası destek'
  },
  {
    icon: 'ri-time-line',
    title: 'Zamanında Teslimat',
    description: 'Belirlenen sürede eksiksiz montaj ve teslim'
  }
];

export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Olmez Mobilya Hakkında
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Olmez Mobilya olarak, yılların deneyimi ve uzman kadromuzla evinize değer katan mobilya çözümleri sunuyoruz. Mutfak dolabı, gardırop, yatak odası takımı ve daha birçok alanda özel tasarım ve üretim hizmetleri veriyoruz.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Kaliteli malzeme kullanımı, titiz işçilik ve müşteri memnuniyeti odaklı yaklaşımımızla her projede fark yaratıyoruz. Hayalinizdeki mobilyaları gerçeğe dönüştürmek için buradayız.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Tüm tezgah çeşitleri, yüklük sistemleri, vestiyer, giyinme odası ve raf sistemleri gibi geniş ürün yelpazemizle evinizin her köşesine özel çözümler üretiyoruz.
            </p>
            <a
              href="https://wa.me/905303030218"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-amber-600 text-white px-8 py-4 rounded-lg hover:bg-amber-700 transition-colors duration-200 font-semibold text-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Bize Ulaşın
            </a>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/24dd4232b72438cacee67788cdb36789.jpg"
              alt="Olmez Mobilya Atölyesi"
              className="rounded-2xl shadow-2xl object-cover object-top w-full h-96"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-6 bg-gray-50 rounded-xl hover:bg-amber-50 transition-colors duration-300"
            >
              <div className="bg-amber-600 text-white w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
                <i className={`${feature.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
